import { useMemo } from 'react';
import {
  APIPageQueryOptions,
  APIPageQueryResult,
  useAPIPageQuery,
} from 'shared/api/APIPageQuery';
import { APIQueryResult, useAPIQuery } from 'shared/api/APIQuery';
import {
  LoadboardAPIResponse,
  requestJSONLoadboardAPI,
} from 'shared/api/LoadboardAPIClient';
import { ShipperReportDTO } from './ShipperReportDTO';
import {
  ShipperExperienceDTO,
  shipperExperienceSchema,
  ShipperProfileDTO,
  shipperProfileSchema,
} from './ShipperProfileDTO';

export function useShipperProfile(
  guid: string | undefined | null,
): APIQueryResult<ShipperProfileDTO> {
  return useAPIQuery(
    ['shippers', 'profile', { guid }],
    () =>
      requestJSONLoadboardAPI([
        'GET /internal/v3/shippers/{guid}/profile',
        { guid },
      ]),
    { enabled: !!guid, schema: shipperProfileSchema },
  );
}

export function useShipperExperienceList(
  guids: Array<string | undefined>,
  {
    enabled = true,
    ...options
  }: APIPageQueryOptions<ShipperExperienceDTO> = {},
): APIPageQueryResult<ShipperExperienceDTO> {
  const filteredGuids = guids.filter(Boolean);
  return useAPIPageQuery(
    ['shippers', 'experience', filteredGuids],
    () =>
      requestJSONLoadboardAPI('POST /internal/v3/shippers/experience', {
        json: { guids },
      }),
    {
      enabled: filteredGuids.length > 0 && enabled,
      schema: shipperExperienceSchema,
      ...options,
    },
  );
}

export function useShipperAPI() {
  return useMemo(
    () => ({
      reportShipper: (guid: string, values: ShipperReportDTO) =>
        requestJSONLoadboardAPI<LoadboardAPIResponse<ShipperReportDTO | null>>(
          ['POST /internal/v3/shippers/{guid}/complaints/', { guid }],
          {
            json: values,
            parseJSON: (json) => {
              //temporal fix until backend will return correct response
              if (!json) {
                return { data: null };
              }

              return { data: JSON.parse(json) as ShipperReportDTO };
            },
          },
        ),
    }),
    [],
  );
}
